import { getGlossary, findGlossaryItemByTrigger, DATA_GLOSSARY_TRIGGER_ATTR, highlightGlossaryItems, } from '@as-react/common-utils';
import { useEffect, useRef, useState } from 'react';
/**
 * Hook for managing glossary tooltips within popovers.
 * Finds already-highlighted elements and returns data for rendering Tooltip or Popover components.
 *
 * @param scrollContainer - Ref to the popover scroll container
 * @param isPopoverOpen - Whether the popover is currently open
 * @returns Object with highlighted elements for tooltip rendering
 */
export const useGlossaryHighlightInPopover = (scrollContainer, isPopoverOpen) => {
    const isProcessed = useRef(false);
    const [highlightedElements, setHighlightedElements] = useState([]);
    useEffect(() => {
        const processHighlightedItems = () => {
            if (!scrollContainer || !scrollContainer.current) {
                return;
            }
            const glossary = getGlossary();
            if (!glossary) {
                return;
            }
            highlightGlossaryItems(glossary, scrollContainer.current);
            const highlightedItems = scrollContainer.current.querySelectorAll(`a[${DATA_GLOSSARY_TRIGGER_ATTR}]`);
            const elements = [];
            highlightedItems.forEach(item => {
                var _a;
                const trigger = (_a = item.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim();
                if (trigger) {
                    const glossaryItem = findGlossaryItemByTrigger(trigger, glossary);
                    if (glossaryItem) {
                        elements.push({
                            element: item,
                            glossaryItem,
                        });
                    }
                }
            });
            setHighlightedElements(elements);
        };
        if ((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.current) && !isProcessed.current) {
            isProcessed.current = true;
            processHighlightedItems();
        }
    }, [isPopoverOpen, scrollContainer]);
    useEffect(() => {
        if (!isPopoverOpen) {
            isProcessed.current = false;
            setHighlightedElements([]);
        }
    }, [isPopoverOpen]);
    return { highlightedElements };
};
